<ntv-button
    [variant]="variant()"
    [size]="btnSize()"
    [type]="btnType()"
    [disabled]="disabled()"
    [customColor]="customColor()"
    [color]="customColor() && 'custom'"
    (click)="onClick($event)">
    <div class="btn" [class]="btnGap()">
        <span class="btn__text">{{ label() }}</span>
        <span>
            <svg [attr.width]="iconSize().width" [attr.height]="iconSize().height">
                <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#' + iconKey()"></use>
            </svg>
        </span>
    </div>
</ntv-button>
